import _Model from "./_Model";
import Rule from "./Rule";

export default class Validator extends _Model {
  constructor(json) {
    super(json);
    this.rules = Validator.getMappedOrDefault(json, 'rules', [], data => (data || []).map(d => new Rule(d || {})));
    this.failedRules = Validator.getMappedOrDefault(json, 'failedRules', [], data => (data || []).map(d => new Rule(d || {})));

    this.valid = Validator.getMappedOrDefault(json, 'valid', this.failedRules.length === 0, data => !!data);
  }

}
